// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {

});

export function slideshow1_mouseIn(event) {
   $w("#slideshow1").play() 
}
